'use client'

import { ReactNode, useEffect, useSyncExternalStore } from 'react'
import { useTheme } from 'next-themes'
import { ProgressProvider } from '@bprogress/next/app'

type PropsType = {
  children: ReactNode
}

// Hydration-safe mounted check using useSyncExternalStore
const emptySubscribe = () => () => {}
const getSnapshot = () => true
const getServerSnapshot = () => false

const AppProgressProvider = ({ children }: PropsType) => {
  const { theme } = useTheme()
  const mounted = useSyncExternalStore(emptySubscribe, getSnapshot, getServerSnapshot)

  useEffect(() => {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          const htmlElement = document.documentElement
          if (htmlElement.classList.contains('bprogress-busy')) {
            setTimeout(() => {
              if (htmlElement.classList.contains('bprogress-busy')) {
                htmlElement.classList.remove('bprogress-busy')
              }
            }, 500)
          }
        }
      })
    })

    observer.observe(document.documentElement, { attributes: true })

    return () => {
      observer.disconnect()
    }
  }, [])

  // Use a consistent color for initial render to avoid hydration mismatch
  // Only apply theme-based color after client-side hydration is complete
  const progressColor = mounted && theme === 'dark' ? '#629eff' : '#3b82f6'

  return (
    <ProgressProvider color={progressColor} height="2px" options={{ showSpinner: false }} shallowRouting>
      {children}
    </ProgressProvider>
  )
}

export default AppProgressProvider
